import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import { FaWifi } from 'react-icons/fa';
import './OfflineBanner.css';

/**
 * OfflineBanner - Shows when the app is in offline mode
 *
 * Features:
 * - Shows offline status with icon
 * - Displays time remaining until auto-logout (8 hours)
 * - Styled to be noticeable but not intrusive
 */
const OfflineBanner = () => {
  const { isOffline, offlineSince } = useAuth();
  const { t } = useLanguage();

  if (!isOffline) return null;

  // Calculate time remaining (8 hours grace period)
  const getTimeRemaining = () => {
    if (!offlineSince) return null;

    const gracePeriodMs = 8 * 60 * 60 * 1000; // 8 hours
    const elapsed = Date.now() - offlineSince;
    const remaining = gracePeriodMs - elapsed;

    if (remaining <= 0) return null;

    const hours = Math.floor(remaining / (60 * 60 * 1000));
    const minutes = Math.floor((remaining % (60 * 60 * 1000)) / (60 * 1000));

    if (hours > 0) {
      return `${hours}h ${minutes}m`;
    }
    return `${minutes}m`;
  };

  const timeRemaining = getTimeRemaining();

  return (
    <div className="offline-banner">
      <div className="offline-banner-content">
        <FaWifi className="offline-icon" />
        <span className="offline-text">
          {t('offlineBanner') || 'Du bist offline. Änderungen werden synchronisiert, sobald die Verbindung wiederhergestellt ist.'}
        </span>
        {timeRemaining && (
          <span className="offline-timer" title="Zeit bis automatischer Logout">
            ({timeRemaining})
          </span>
        )}
      </div>
    </div>
  );
};

export default OfflineBanner;
